import { CurrentUser } from '@root/types';
import Metric from '@components/shared/Metric';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'antd';
import { useFlags } from 'launchdarkly-react-client-sdk';

import OnlyInMobile from '@components/shared/OnlyInMobile';
import OnlyInDesktopTablet from '@components/shared/OnlyInDesktopTablet';
import {
  EmailDisplay,
  FirstNameDisplay,
  LastNameDisplay,
} from '@components/layouts/Truva/AccountSettings/utils';
import s from '../AccountSettings.module.less';

type Props = {
  currentUser: CurrentUser;
};

const ProfessionalInfoContent = ({ currentUser }: Props) => {
  const { t } = useTranslation('accountSettings');
  const flags = useFlags();
  const usePhoneNumberFormat = flags['phone-number-format'];

  const mobilePhoneDisplayFormatted = (
    <Metric
      className={s.accountItem}
      label={t('mobilePhone')}
      value={t('common:formattedPhone', { formattedPhone: currentUser.phoneNumber })}
    />
  );

  const mobilePhoneDisplay = (
    <Metric
      className={s.accountItem}
      label={t('mobilePhone')}
      value={currentUser.formattedPhoneNumber}
    />
  );
  const jobTitleDisplay = (
    <Metric className={s.accountItem} label={t('jobTitle')} value={currentUser.jobTitle} />
  );

  const locationDisplay = (
    <Metric className={s.accountItem} label={t('market')} value={currentUser.marketName} />
  );

  const roleDisplay = (
    <Metric
      className={s.accountItem}
      label={t('professionalRole')}
      value={t(`common:roles.${currentUser.role}`)}
    />
  );

  return (
    <>
      <Row className={s.emailRow}>
        <Col>
          <EmailDisplay currentUser={currentUser} />
        </Col>
      </Row>
      <OnlyInMobile>
        <div className={s.inputGrid}>
          <FirstNameDisplay currentUser={currentUser} />
          <LastNameDisplay currentUser={currentUser} />
          {usePhoneNumberFormat ? mobilePhoneDisplayFormatted : mobilePhoneDisplay}
          {locationDisplay}
          {jobTitleDisplay}
          {roleDisplay}
        </div>
      </OnlyInMobile>
      <OnlyInDesktopTablet>
        <div className={s.inputGrid}>
          <FirstNameDisplay currentUser={currentUser} />
          <LastNameDisplay currentUser={currentUser} />
          {usePhoneNumberFormat ? mobilePhoneDisplayFormatted : mobilePhoneDisplay}
          {locationDisplay}
          {jobTitleDisplay}
          {roleDisplay}
        </div>
      </OnlyInDesktopTablet>
    </>
  );
};

export default ProfessionalInfoContent;
